import merge from 'lodash/merge';
import pickBy from 'lodash/pickBy';
import { filtersFromRefinements, sortOrderFactory, currentLocationFactory } from './query/filtersFromRefinements';

export default (refinements) => {
  const query = merge({}, refinements);
  delete (query.channelObject);
  delete (query.minPrice);
  delete (query.maxPrice);
  delete (query.localities);
  delete (query.page);
  delete (query.sortObject);

  const currentLocation = currentLocationFactory(refinements.currentLocation, refinements.where);
  const filters = merge(
    filtersFromRefinements(refinements),
    pickBy({ 'tenure-type': refinements.tenureTypeObject.bff }),
  );

  return merge(
    {
      channel: refinements.channelObject.id,
      localities: refinements.localities,
      filters,
      page: refinements.page,
      sort: sortOrderFactory(refinements.channelObject, refinements.sortObject),
    }, currentLocation);
};
